export default __webpack_public_path__ + "static/media/smoothie_blue.941eae96.png";